import { motion } from "framer-motion";

const items = [
  {
    kind: "num",
    value: "10",
    suffix: "+",
    label: "Év",
    sublabel: "Szakmai tapasztalat",
  },
  {
    kind: "num",
    value: "40",
    suffix: "+",
    label: "Vendég",
    sublabel: "Visszatérő bizalom",
  },
  {
    kind: "mark",
    glyph: "✦",
    label: "Diszkrét",
    sublabel: "Prémium környezet",
  },
  {
    kind: "mark",
    glyph: "✦",
    label: "Személyre",
    sublabel: "Szabott figyelem",
  },
];

const TrustBar = () => {
  return (
    <section
      data-testid="trust-bar"
      className="relative py-20 md:py-28 bg-anthracite-950"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid grid-cols-2 lg:grid-cols-4">
          {items.map((item, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: idx * 0.12, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`trust-item-${idx}`}
              className={`relative py-8 md:py-10 px-3 sm:px-5 md:px-8 ${
                idx < 3 ? "lg:border-r border-gold-500/15" : ""
              } ${idx === 0 || idx === 2 ? "border-r lg:border-r border-gold-500/15" : ""} ${
                idx >= 2 ? "border-t lg:border-t-0 border-gold-500/15" : ""
              }`}
            >
              {item.kind === "num" ? (
                <div className="flex items-baseline gap-1">
                  <span className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-light text-cream leading-none">
                    {item.value}
                  </span>
                  <span className="font-serif text-2xl sm:text-3xl md:text-4xl text-gold-500 italic font-light">
                    {item.suffix}
                  </span>
                </div>
              ) : (
                <div className="flex items-center gap-3 leading-none">
                  <span className="font-serif text-gold-500 italic font-light text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
                    {item.glyph}
                  </span>
                </div>
              )}

              <div className="mt-6 pt-6 border-t border-white/10 max-w-[160px]">
                <div className="text-[10px] uppercase tracking-[0.4em] text-gold-500 mb-2">
                  {item.label}
                </div>
                <div className="text-xs md:text-sm text-cream/50 font-light leading-relaxed">
                  {item.sublabel}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
